import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import TermLink from "./TermLink";
import { FIELD_TNC } from "landing/components/SubscriptionForm";
import type { LandingPageConfig } from "landing/objects/LandingPageConfig";
import CheckboxInput from "shared/forms/inputs/CheckboxInput";

export const FIELD_TNC2 = "TNC2";

export interface IUSTermTemplateProps {
  landingPageConfig: LandingPageConfig;
}

export default (props: IUSTermTemplateProps) => {
  const { landingPageConfig } = props;
  const values = useMemo(
    () => ({
      ...landingPageConfig,
      tncTerm: (
        <TermLink
          termClass={landingPageConfig.tncTermClass}
          url={landingPageConfig.tncTermUrl}
          text={landingPageConfig.tncTermText}
        >
          <FormattedMessage id="landing.subscription.field.terms_and_conditions.tnc" />
        </TermLink>
      ),
      prvTerm: (
        <TermLink
          termClass={landingPageConfig.prvTermClass}
          url={landingPageConfig.prvTermUrl}
          text={landingPageConfig.prvTermText}
        >
          <FormattedMessage id="landing.subscription.field.terms_and_conditions.prv" />
        </TermLink>
      ),
      ttcTerm: (
        <TermLink
          termClass={landingPageConfig.ttcTermClass}
          url={landingPageConfig.ttcTermUrl}
          text={landingPageConfig.ttcTermText}
        >
          <FormattedMessage id="landing.subscription.field.terms_and_conditions.ttc" />
        </TermLink>
      ),
      otcTerm: (
        <TermLink
          termClass={landingPageConfig.otcTermClass}
          url={landingPageConfig.otcTermUrl}
          text={landingPageConfig.otcTermText}
        >
          <FormattedMessage id="landing.subscription.field.terms_and_conditions.otc" />
        </TermLink>
      ),
      stop: (
        <strong>
          <FormattedMessage id="landing.subscription.field.terms_and_conditions.stop" />
        </strong>
      ),
    }),
    [landingPageConfig],
  );
  return (
    <>
      <CheckboxInput
        inputID={FIELD_TNC}
        label={
          <FormattedMessage
            id="landing.subscription.field.terms_and_conditions.1"
            values={values}
          />
        }
      />
      <CheckboxInput
        inputID={FIELD_TNC2}
        label={
          <FormattedMessage
            id="landing.subscription.field.terms_and_conditions.2"
            values={values}
          />
        }
      />
      <p>
        <FormattedMessage
          id="landing.subscription.field.terms_and_conditions.3"
          values={values}
        />
      </p>
    </>
  );
};
